/**
 * Major-unit decimal <-> integer minor-unit conversions for the manual entry
 * form (E2 brief: gross sales / payout / tax are typed as decimal major
 * units, at most 2dp, non-negative, and stored on the wire as integer minor
 * units x100). Pure so the parse/reject rules are unit-testable without a
 * rendered field.
 */

const MAJOR_AMOUNT_RE = /^\d+(\.\d{1,2})?$/;

/**
 * Parses a decimal major-unit string (e.g. "123.4") into integer minor
 * units (12340). Returns null for anything that is not a non-negative
 * number with at most 2 decimal places, including blank input.
 */
export function parseMajorAmount(input: string): number | null {
  const trimmed = input.trim();
  if (!MAJOR_AMOUNT_RE.test(trimmed)) return null;
  const [whole, frac = ''] = trimmed.split('.');
  const minor = Number(whole) * 100 + Number(frac.padEnd(2, '0'));
  return Number.isSafeInteger(minor) ? minor : null;
}
